export const SET_LOADING = 'SET_LOADING';
export const ADD_ITEM = 'ADD_ITEM';

export const SET_CURRENT = 'SET_CURRENT';
export const RESET_CURRENT = 'RESET_CURRENT';

export const UPDATE_ITEM = 'UPDATE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';

export const TOGGLE_BOUGHT = 'TOGGLE_BOUGHT';

export const CLEAR_LIST = 'CLEAR_LIST';
export const CLEAR_BOUGHT = 'CLEAR_BOUGHT';
